







































import TitleMedium from "@/common/components/atoms/TitleMedium.vue";
import TextLabel from "@/common/components/atoms/TextLabel.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconFavoriteCircle from "@/common/components/icons/IconFavoriteCircle.vue";
import IconFavorite56px from "@/common/components/icons/IconFavorite56px.vue";
import { Prop, Component, Vue } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";
import globals from "@/general/store/modules/globals";

@Component({
  components: {
    TitleMedium,
    TextLabel,
    IconBase,
    IconFavoriteCircle,
    IconFavorite56px
  },
  filters: {
    addComma(value: any) {
      const number = Number(value);
      if (Number.isNaN(number)) {
        return value;
      }
      return number.toLocaleString();
    }
  }
})
export default class ItemListPanel extends Vue {
  @Prop({ type: [String, Number], required: true }) id!: string | number;
  @Prop({ type: String, required: true }) imgPath!: string;
  @Prop({ type: String, required: true }) name!: string;
  @Prop({ type: String, required: true }) color!: string;
  @Prop({ type: Number, required: true }) point!: number;
  @Prop({ type: Number, required: false }) discountRate!: number;
  @Prop({ type: Boolean, required: true }) isFavorite!: boolean;
  @Prop({ type: String, required: false }) status!: string;
  @Prop({ type: Boolean, default: false }) addToBrowserHistory!: boolean;
  @Prop({ type: Number, required: false, default: 0 }) stock!: number;
  @Prop({ type: Boolean, required: false, default: false })
  stockControl!: boolean;

  internalFavoriteState: any = "";

  get unit() {
    return commons.OrgPageSpecific?.point_name;
  }

  get browser() {
    return globals.browser;
  }

  get isIe() {
    //return globals.browser === "ie";
    return false;
  }

  get setOpacity() {
    if (!this.stockControl) {
      return { opacity: 1 };
    }
    if (!this.stock) {
      return { opacity: 0.3 };
    }
    return false;
  }

  async created() {
    await commons.setOrgPageSpecificDataFromLocalStorage();
    this.initFavoriteState();
  }

  toggleFavorite() {
    this.internalFavoriteState = !this.internalFavoriteState;
  }
  initFavoriteState() {
    this.internalFavoriteState = this.isFavorite;
  }

  viewProductDetails(id: number) {
    window.location.href = "/product-details/?id=" + id;
  }
}
